import { render } from "./senatorsComponent.vue?vue&type=template&id=5c8e4a4d"
import script from "./senatorsComponent.vue?vue&type=script&lang=js"
export * from "./senatorsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__